import { type ComponentRef, forwardRef } from "react";
import {
	PlateElement,
	type PlateElementProps,
} from "@platejs/core/react";
import type { TLinkElement } from "@platejs/utils";
import { useLink } from "@platejs/link/react";

export const LinkElement = forwardRef<
	ComponentRef<typeof PlateElement>,
	PlateElementProps<TLinkElement>
>(({ children, ...props }, ref) => {
	const { props: linkProps } = useLink({ element: props.element });

	return (
		<PlateElement as="a" ref={ref} {...linkProps} {...(props as any)}>
			{children}
		</PlateElement>
	);
});

LinkElement.displayName = "LinkElement";
